<template>
    <v-card flat>
        <v-card-text>
            <v-container fluid>
                <v-layout>

                    <v-flex>
                        <v-select label="Clients"
                                  autocomplete :loading="loading"
                                  required
                                  :items="items"
                                  :search-input.sync="search"
                                  v-model="select"
                                  item-text="name"
                                  item-value="id">

                        </v-select>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
    </v-card>
</template>


<script>
    import {
        Api
    } from '../../../services';
    import queryString from 'query-string';
    import Loader from '../Components/Loader.vue';
    import _ from 'lodash';

    export default {
        data() {
            return {
                loading: false,
                items: [],
                search: null,
                select: false,
                states: []
            }
        },
        watch: {
            search(val) {
                val
            },
            select(newVal) {
                if (_.isNumber(newVal)) {
                    console.log('clientId', newVal);
                    this.$emit('selected', newVal);
                } else {
                    if (_.isNull(newVal)) {
                        this.$emit('selected');
                    }
                }
            }
        },
        mounted() {
            this.loading = true;
            Api
                .Clients()
                .all()
                .then((res) => {
                    console.log('CLIENTS: ', res.data);
                    return this.items = _.sortBy(res.data, client => client.name);
                })
                .then(() => this.loading = false)
                .catch(err => {
                    console.log('ERRRR', err);
                    this.loading = false
                })
        },
        methods: {
            querySelections(name) {
                // setTimeout(() => {
                //     this.items = this.items.filter(e => {
                //         return (name || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
                //     })
                //     this.loading = false
                // }, 500)
            }
        }
    }
</script>


<style>
    /* .primary--text{
        color: #757575!important;
    } */
</style>



// WEBPACK FOOTER //
// src/components/Admin/Reports/ClientSelector.vue